<template>
    <Card :title="$t('labels.order_status')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.name')" :required="true">
                        <Input v-model="orderStatus.name" type="string" />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.type')" :required="true">
                        <AppSelect
                            :model-value="selectedType.value"
                            :selected-value="selectedType.label"
                            :options="typeOptions"
                            @update:model-value="selectedType = $event"
                            option-key="value"
                            option-value="label"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.color')" :required="true">
                        <Input v-model="orderStatus.color" type="color" />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.exit_declaration_status')">
                        <Autocomplete 
                            url="/management/exit-declaration-statuses"
                            :model-value="exitDeclarationStatus?.uuid"
                            :selected-value="exitDeclarationStatus?.name"
                            :can-be-empty="true"
                            @update:model-value="exitDeclarationStatus = $event"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="create">
                <i class="icon-floppy-disk mr-2"></i>
                <span>{{ $t('buttons.create') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";
import Autocomplete from "../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import AppSelect from "../../../../components/new/form/select/AppSelect.vue";

import { httpClient } from "../../../../services/HttpClient";
import { OrderStatusTypeEnum } from "../../../enums/OrderStatusTypeEnum";

export default {
    name: "OrderStatusCreatePage",
    components: {
        Card, FormGroup, Input, AppButton, Autocomplete, AppSelect
    },
    data() {
        return {
            OrderStatusTypeEnum,
            orderStatus: {
                name: null,
                color: '#000000',
            },
            exitDeclarationStatus: null,
            selectedType: {
                value: OrderStatusTypeEnum.ACTIVE,
                label: this.$t('orderStatus.types.active')
            },
            typeOptions: [
                { value: OrderStatusTypeEnum.ACTIVE, label: this.$t('orderStatus.types.active') },
                { value: OrderStatusTypeEnum.DONE, label: this.$t('orderStatus.types.done') },
                { value: OrderStatusTypeEnum.CANCELED, label: this.$t('orderStatus.types.canceled') },
            ]
        }
    },
    methods: {
        create() {
            httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/statuses`, {
                name: this.orderStatus.name,
                color: this.orderStatus.color,
                exit_declaration_status_uuid: this.exitDeclarationStatus?.uuid ?? null,
                type: this.selectedType.value
            }).then((response) => {
                this.$router.push({ name: 'OrderStatusEditPage', params: { orderStatusUuid: response.data.data.uuid } });
            })
        }
    }
}
</script>